// src/components/LogoutModal.jsx
// Shared logout confirmation modal used by both AccountPage and Navbar.
import { useEffect } from "react";

export function LogoutModal({ onConfirm, onCancel }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onCancel]);

  return (
    <div
      className="lm-backdrop"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}
      role="dialog" aria-modal="true" aria-label="Sign out confirmation"
    >
      <div className="lm-modal">
        <div className="lm-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </div>
        <h2 className="lm-title">Sign out?</h2>
        <p className="lm-body">You'll need to sign in again to access your account, orders and wishlist.</p>
        <div className="lm-actions">
          <button className="lm-btn lm-btn--cancel"  onClick={onCancel}>Stay signed in</button>
          <button className="lm-btn lm-btn--confirm" onClick={onConfirm}>Yes, sign out</button>
        </div>
      </div>

      <style>{`
        .lm-backdrop{position:fixed;inset:0;z-index:9999;background:rgba(1,15,50,.6);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:20px;font-family:'Roboto',sans-serif;}
        .lm-modal{background:#fff;border-radius:18px;padding:36px 32px;max-width:380px;width:100%;text-align:center;box-shadow:0 8px 40px rgba(1,15,50,.22);animation:lm-in .2s cubic-bezier(.34,1.3,.64,1);}
        @keyframes lm-in{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}
        .lm-icon{width:60px;height:60px;border-radius:50%;background:#fef2f2;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;}
        .lm-title{font-size:20px;font-weight:800;color:#0f1c38;margin-bottom:10px;}
        .lm-body{font-size:14px;color:#6b7a99;line-height:1.6;margin-bottom:28px;}
        .lm-actions{display:flex;gap:10px;}
        .lm-btn{flex:1;padding:12px 16px;border-radius:10px;border:none;font-family:'Roboto',sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:all .18s;}
        .lm-btn--cancel{background:#f0f4fa;color:#374151;border:1.5px solid #e2e8f0;}
        .lm-btn--cancel:hover{background:#e4ebf5;color:#013d97;}
        .lm-btn--confirm{background:#dc2626;color:#fff;}
        .lm-btn--confirm:hover{background:#b91c1c;}
        @media(max-width:480px){.lm-modal{padding:28px 20px;}}
      `}</style>
    </div>
  );
}

export default LogoutModal;